// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3sUym","amount":"Amount_amount__1Lx8Z","tip":"Amount_tip__2HTUU","tipHeader":"Amount_tipHeader__3JTUR","tipsWrap":"Amount_tipsWrap__2_Z_8"};